import { ReactElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { divIcon, DivIcon } from "leaflet";
import { IconAnchorStyle } from "./markerLayout";

/**
 * Leaflet's `Marker` doesn't accept live React children as its icon — the
 * standard bridge is `divIcon`, which takes a raw HTML string. Rendering our
 * marker components with `renderToStaticMarkup` keeps every marker's visual
 * definition (BaseMarker + friends) as the single source of truth for both
 * providers instead of hand-duplicating SVG/CSS for Leaflet specifically.
 * These icons are presentation-only (no click handlers), so losing React
 * interactivity in the static markup costs nothing here.
 */
export function createLeafletIcon(node: ReactElement, size: [number, number], anchor: IconAnchorStyle): DivIcon {
  const [width, height] = size;
  const iconAnchor: [number, number] = anchor === "center" ? [width / 2, height / 2] : [width / 2, height];

  return divIcon({
    html: renderToStaticMarkup(node),
    className: "v2-map-marker", // strips Leaflet's default divIcon box — see OsmMapAdapter.module.css
    iconSize: [width, height],
    iconAnchor,
  });
}
